import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './ActiveFiltersSummary.module.css';

const DismissIcon = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
    <path
      d="M7.5 2.5L2.5 7.5M2.5 2.5l5 5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

/**
 * ActiveFiltersSummary — shows active filters in sidebar with dismiss buttons.
 *
 * @param {Array} filters - Array of { label, displayValue, onRemove }
 * @param {Function} onClearAll - Called when "Clear all" is clicked
 */
const ActiveFiltersSummary = ({ filters = [], onClearAll }) => {
  if (filters.length === 0) return null;

  return (
    <div className={css.root}>
      <div className={css.heading}>
        <span className={css.headingText}>Active filters</span>
        <button className={css.clearAll} onClick={onClearAll} type="button">
          <FormattedMessage id="SearchFiltersMobile.resetAll" />
        </button>
      </div>
      <div className={css.chips}>
        {filters.map(f => (
          <button key={f.key || f.label} type="button" className={css.chip} onClick={f.onRemove}>
            <span className={css.chipText}>
              {f.displayValue ? `${f.label}: ${f.displayValue}` : f.label}
            </span>
            <DismissIcon />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ActiveFiltersSummary;
